import { Component, inject, QueryList, ViewChild, ViewChildren } from '@angular/core'
import { NavigationStart, Router, RouterLink, RouterLinkActive } from '@angular/router'
import { LayoutService } from '../layout.service'
import { NzMenuDirective, NzMenuItemComponent, NzSubMenuComponent } from 'ng-zorro-antd/menu'
import { NzIconDirective } from 'ng-zorro-antd/icon'

@Component({
  selector: 'app-slider-menu',
  templateUrl: './slider-menu.component.html',
  styleUrl: './slider-menu.component.sass',
  imports: [NzMenuDirective, RouterLinkActive, NzMenuItemComponent, NzIconDirective, RouterLink],
})
export class SliderMenuComponent {
  layoutService = inject(LayoutService)
  isCollapsed = this.layoutService.isCollapsed
  cdk = inject(LayoutService).isCollapsed

  @ViewChildren(NzSubMenuComponent) submenu!: QueryList<NzSubMenuComponent>
  @ViewChild(NzMenuDirective, { static: true }) liEvents!: NzMenuDirective

  constructor(private router: Router) {
    this.router.events.subscribe(event => this.layoutService.onChangeRoute(event as NavigationStart))
  }
}
